import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateFormTemplateMutation, useDuplicateFormTemplateMutation } from '../../../../hooks/mutations/useFormTemplateMutation';
import { useFormTypesQuery } from '../../../../hooks/queries/useFormTypesQuery';
import CustomTextInput from '../../../CustomTextInput';
import DropDown, { OptionType } from '../../../DropDown';
import ModalBody, { ModalProps } from '../../ModalBody';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../../../utils/capitalize';

interface DuplicateFormModalProps extends ModalProps {
    refetch?: () => void;
    initialFormId: string;
    initialTitle: string;
}

const DuplicateFormModal: React.FC<DuplicateFormModalProps> = ({ open, handleClose, refetch = () => {}, initialFormId, initialTitle }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [selectedFormType, setSelectedFormType] = useState<OptionType | null>(null);
    const [formTitle, setFormTitle] = useState(`${capitalizeFirstLetter(t('copyOf'))} ${initialTitle}`);

    const { data: dataFormTypes, isLoading: isFormTypesLoading } = useFormTypesQuery({ queries: { active: true } });
    const { mutate: duplicateFormTemplate } = useDuplicateFormTemplateMutation({
        onSuccess: (data) => {
            navigate(`/qhse/forms/${data.data._id}`);
            refetch();
        },
    });

    return (
        <ModalBody
            closeText={t('cancel')}
            okText={t('createCopy')}
            title={t('form')}
            subTitle={t('createCopy')}
            open={open}
            handleClose={handleClose}
            handleOk={() => {
                duplicateFormTemplate({ templateId: initialFormId, title: formTitle });
            }}
            disabledOk={!formTitle.length}
        >
            <CustomTextInput value={formTitle} onChange={(text) => setFormTitle(text)} label={t('title')} required />
        </ModalBody>
    );
};

export default DuplicateFormModal;
